import {OidcMetadata, User, UserManager, UserManagerSettings} from 'oidc-client';
import { anabClientConfig } from "@/AppConfig";
import { useGlobalStore } from "@/stores/GlobalStore";
export default class OAuthService {
    public userManager: UserManager;    

    constructor(metdata: OidcMetadata | undefined = undefined) {
        const globalStore = useGlobalStore();

        const settings: UserManagerSettings = {
            authority: globalStore.settings.startupConfig?.idsUrl,
            client_id: anabClientConfig.clientId,
            redirect_uri: window.location.origin + "/sso/oAuthCallback",
            silent_redirect_uri: window.location.origin + "/sso/oAuthCallback/silent",
            automaticSilentRenew: true,
            response_type: 'code',
            scope: anabClientConfig.scopes,
            post_logout_redirect_uri: window.location.origin + '/logout',
            filterProtocolClaims: false,
            metadata: metdata
        };

        this.userManager = new UserManager(settings);
    }

    public async login(): Promise<void> {
        return await this.userManager.signinRedirect();
    }

    public async loginByCustomView(view: string): Promise<void> {
        return await this.userManager.signinRedirect({
            extraQueryParams: {
                viewName: view
            }
        });
    }

    public async logout(): Promise<void> {
        return await this.userManager.signoutRedirect();
    }

    public async refreshTokensSilently(): Promise<User | undefined> {
        return await this.userManager.signinSilentCallback();
    }
}
